<template>
  <div class="d-flex align-center justify-center">
    <!-- WhatsApp Icon -->
    <a
      v-if="item && item.mobile && !item.attributionMarked"
      @click.stop="handleWhatsAppClick"
      class="mr-2"
      title="Send WhatsApp Link"
      style="cursor: pointer; text-decoration: none"
    >
      <v-icon small color="success">mdi-whatsapp</v-icon>
    </a>
    <span
      v-else-if="item && item.attributionMarked === true"
      class="mr-2"
      title="Transferred - Links disabled"
      style="cursor: not-allowed; opacity: 0.5"
    >
      <v-icon small color="grey">mdi-whatsapp</v-icon>
    </span>
    <!-- Copy Icon -->
    <v-tooltip v-if="item && item.mobile && !item.attributionMarked" bottom max-width="300">
      <template v-slot:activator="{ on, attrs }">
        <a
          v-bind="attrs"
          v-on="on"
          @click.stop="handleCopyClick"
          title="Copy Link"
          style="cursor: pointer; text-decoration: none"
        >
          <v-icon small color="grey">mdi-content-copy</v-icon>
        </a>
      </template>
      <span>{{ copyTooltipText }}</span>
    </v-tooltip>
    <span
      v-else-if="item && item.attributionMarked === true"
      title="Transferred - Links disabled"
      style="cursor: not-allowed; opacity: 0.5"
    >
      <v-icon small color="grey">mdi-content-copy</v-icon>
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ModelVue from "../../ModelVue";
import Helper from "@/util/Helper";

@Component({
  components: {},
})
export default class FCellLinks extends ModelVue {
  @Prop()
  onClickCopy: (item: any) => void;

  @Prop()
  onClickWhatsApp: (item: any) => void;

  @Prop()
  dataSelectorKey: string;

  @Prop({
    default: "Click to copy link",
  })
  copyTooltipText: string;

  @Prop()
  dataSelectorKeyToCopy: string;

  get item() {
    return this.modelValue;
  }

  handleCopyClick() {
    if (!this.item) return;
    
    // Disable if attributionMarked is true (Transferred)
    if (this.item.attributionMarked === true) {
      return;
    }
    
    const linkToCopy = this.dataSelectorKeyToCopy
      ? this.selectModel(this.item, this.dataSelectorKeyToCopy)
      : this.item.dsaCustomerOnboardingLink ||
        this.item.onboardingLink ||
        this.item.signupLink;

    if (linkToCopy) {
      Helper.copyToClipBoard(linkToCopy);
    } else if (this.onClickCopy) {
      this.onClickCopy(this.item);
    }
  }

  handleWhatsAppClick() {
    if (!this.item) return;
    
    // Disable if attributionMarked is true (Transferred)
    if (this.item.attributionMarked === true) {
      return;
    }
    
    if (this.onClickWhatsApp) {
      this.onClickWhatsApp(this.item);
    }
  }
}
</script>

